import React, { Fragment, useState } from "react";
import { SolidButton } from "../../../global/SolidButton";
import { CopyIcon, Delete, PenLine, Plus, Trash } from "lucide-react";
import toast, { Toaster } from "react-hot-toast";
import { linkData } from "../../../../data/linkData";
import { MyModal } from "../../../global/MyModal";
import { RedirectForm } from "../../../util/RedirectForm";

export default function RedirectSetting() {
  // const data = linkData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [rows, setRows] = useState(linkData);
  const data = rows;

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    toast.success("copied to clipboard");
  };

  const copyToJson = (item) => {
    const copy = `{
      "title": "${item.title}",
      "ref": "${item.referenceCode}",
      "link": "${item.redirectLink}",
      "status": ${item.isActive}
    }`;
    
    navigator.clipboard.writeText(copy);

    toast.success("Redirect Configuration copied to clipboard");
  };

  // ------------------------------
  // OPEN ADD MODAL
  // ------------------------------
  const openAddModal = () => {
    setIsEditMode(false);

    setIsModalOpen(true);
  };

  // ------------------------------
  // OPEN EDIT MODAL
  // ------------------------------
  const openEditModal = (item) => {
    setIsEditMode(true);
    setCurrentItem(item);
    //  setNameInput(item.title);
    // setValueInput(item.value);
    setIsModalOpen(true);
  };

  // ------------------------------
  // ADD NEW CONFIG
  // ------------------------------
  const handleAdd = (item) => {
    // Build a row from the form values
    const newItem = {
      id: Date.now(),
      title: item.title,
      referenceCode: item.referenceCode,
      redirectLink: item.redirectLink,
      isActive: true,
      dateTime: new Date().toLocaleString(),
    };

    setRows((prev) => [...prev, newItem]);
    setIsModalOpen(false);
  };

  // ------------------------------
  // UPDATE CONFIG
  // ------------------------------
  const handleUpdate = (values) => {
    if (!currentItem) return;

    const updated = data.map((it) =>
      it.id === currentItem.id
        ? {
            ...it,

            title: values.bonusTitle || it.title,
            referenceCode: values.referenceCode,
            redirectLink: values.redirectLink,
            dateTime: new Date().toLocaleString(),
            isActive: values.isActive || it.isActive,
          }
        : it
    );

    setRows(updated);
    setIsModalOpen(false);
    setCurrentItem(null);
  };

  // ------------------------------
  // DELETE CONFIG
  // ------------------------------
  const handleDelete = () => {
    setRows(data.filter((item) => item.id !== deleteId));
    setDeleteId(null);
  };

  return (
    <Fragment>
      <Toaster />
      <div className="space-y-2">
        <div className="flex flex-row items-center justify-start space-x-4">
          <div className="ml-auto">
            <SolidButton
              onClick={() => openAddModal()}
              children={
                <>
                  <Plus className="w-4 h-4" />
                  <span>Add Redirect</span>
                </>
              }
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 mt-4">
          {data.map((item, index) => (
            <>
              <div
                key={index}
                className="
               bg-slate-200/60 dark:bg-slate-600/60
                border-[0.6px] border-slate-400 dark:border-slate-400
                rounded-lg hover:shadow-sm hover:shadow-gray-600
              dark:hover:shadow-gray-400 p-4 transform duration-200
                flex flex-col 
               "
              >
                {/* top row */}
                <div className="flex flex-row items-start justify-between">
                  <span className="text-xs text-slate-800 dark:text-slate-100 font-semibold">
                    {item.title}
                  </span>
                  <dir className="flex items-center justify-center space-x-4">
                    <CopyIcon
                      onClick={() => copyToJson(item)}
                      className="w-[24px] h-[24px] text-slate-400 dark:text-slate-300 cursor-pointer hover:bg-slate-400/20 hover:dark:bg-slate-400/20 rounded-sm p-[3px] "
                    />

                    {/* Toggle */}
                    <div className="ml-auto flex items-start">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          //      checked={enabled}
                          //    onChange={() => setEnabled(!enabled)}
                        />
                        <div
                          className="w-10 h-5 bg-gray-300 dark:bg-gray-400 
              rounded-full peer peer-checked:bg-blue-600 
              transition-all
              after:content-[''] after:absolute after:w-4 after:h-4 
              after:bg-white after:rounded-full 
              after:top-[2px] after:left-[2px]
              peer-checked:after:translate-x-5 
              after:transition-all"
                        ></div>
                      </label>
                    </div>
                  </dir>
                </div>
                {/* reference  ----------------------*/}
                <span className="text-[12px] text-slate-700 dark:text-slate-300 font-light mt-3 mb-1">
                  reference:
                </span>

                <div className="flex items-center space-x-4 ">
                  <p className="text-[10px] w-full font-light font-sans text-stone-600 dark:text-slate-200 bg-slate-300/40 dark:bg-slate-300/10 px-2 py-1 rounded-xs">
                    {item.referenceCode}
                  </p>
                  <CopyIcon
                    onClick={() => handleCopy(item.referenceCode)}
                    className="w-[18px] h-[18px] text-slate-400 dark:text-slate-300 cursor-pointer hover:bg-slate-400/20 hover:dark:bg-slate-400/20 rounded-sm p-[3px] "
                  />
                </div>
                {/* --------------------------------------------- */}
                {/* link -------------------------*/}
                <span className="text-[12px] text-slate-700 dark:text-slate-300 font-light  mt-4 mb-1">
                  Link:
                </span>
                <div className="flex items-center space-x-4 ">
                  <p className="text-[10px] w-full font-light font-sans text-stone-600 dark:text-slate-200 bg-slate-300/40 dark:bg-slate-300/10 px-2 py-1 rounded-xs">
                    {item.redirectLink}
                  </p>
                  <CopyIcon
                    onClick={() => handleCopy(item.redirectLink)}
                    className="w-[18px] h-[18px] text-slate-400 dark:text-slate-300 cursor-pointer hover:bg-slate-400/20 hover:dark:bg-slate-400/20 rounded-sm p-[3px] "
                  />
                </div>
                {/* --------------------------------- */}
                {/* line */}
                <div className="border-b-1 border-slate-300 dark:border-gray-500 my-4"></div>
                {/* action row */}
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-slate-700 dark:text-slate-300 font-light ">
                    {"Created:" + item.dateTime}
                  </span>
                  <div className="flex space-x-6">
                    <PenLine
                      onClick={() => openEditModal(item)}
                      className="w-[22px] h-[22px] text-slate-400 dark:text-slate-300 cursor-pointer hover:bg-slate-400/20 hover:dark:bg-slate-400/20 rounded-sm p-[3px] "
                    />
                    <Trash
                      onClick={() => setDeleteId(item.id)}
                      className="w-[22px] h-[22px] text-red-500 cursor-pointer hover:bg-slate-400/20 hover:dark:bg-slate-400/20 rounded-sm p-[3px]"
                    />
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Redirect" : "Add New Redirect"}
        onClose={() => setIsModalOpen(false)}
        width="560px"
      >
        <RedirectForm
          isEditMode={isEditMode}
          handleAdd={handleAdd}
          handleUpdate={handleUpdate}
          onCancel={() => setIsModalOpen(false)}
          initialValues={
            isEditMode && currentItem
              ? {
                  title: currentItem.title || "",

                  referenceCode: currentItem.referenceCode || "",
                  redirectLink: currentItem.redirectLink || "",
                  isActive: currentItem.isActive,
                }
              : undefined
          }
        ></RedirectForm>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Archive Redirect?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to archive this Redirect?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
